<template>
<div>
  <van-nav-bar title="阶段活动奖励" left-text="" left-arrow @click-left="onClickLeft()">
  </van-nav-bar>
  <van-divider content-position="left">活动说明</van-divider>
  <div style="text-align:center;">
    <img src="../../assets/draw2025/reward2.png" style="width:100%;margin-top:2%;" />
  </div>
  <van-divider content-position="left">活动单量</van-divider>
  <div style="height:450px;overflow-y:auto;">
    <!-- <div style="margin-top:5px;">
      <van-cell-group>
        <van-cell title="阶段单量" :value="periodnum" />
        <van-cell title="半年度单量" :value="halfnum" />
        <van-cell title="签约状态" :value="signstatus" />
      </van-cell-group>
    </div>
    <van-divider content-position="left">活动奖励领取</van-divider>
    <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>奖励明细</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ 1 }}</td>
            <td>500积分</td>
            <td>
              <van-button type="primary" size="small" disabled v-if="isreceive21==1">已领取</van-button>
              <van-button type="primary" size="small" disabled v-else-if="isreceive22==1">已领取其他奖励</van-button>
              <van-button type="primary" size="small" v-else-if="isreceive21==0&&isreceive22==0&&(signstatus=='已签约'&&periodnum>=3&&halfnum>=6)" @click="receive(21,1)">立即领取</van-button>
              <van-button type="primary" size="small" disabled v-else>等待领取</van-button>
            </td>
          </tr>
          <tr>
            <td>{{ 2 }}</td>
            <td>200加油卡</td>
            <td>
              <van-button type="primary" size="small" disabled v-if="isreceive22==1">已领取</van-button>
              <van-button type="primary" size="small" disabled v-else-if="isreceive21==1">已领取其他奖励</van-button>
              <van-button type="primary" size="small" v-else-if="isreceive21==0&&isreceive22==0&&((signstatus=='未签约'&&periodnum>=3)||(signstatus=='已签约'&&periodnum>=3&&halfnum<6))" @click="receive(22,2)">立即领取</van-button>
              <van-button type="primary" size="small" disabled v-else>等待领取</van-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->
    <div style="margin-top:5px;">
      <van-cell-group>
        <van-cell title="阶段单量" :value="periodnum" />
      </van-cell-group>
    </div>
    <van-divider content-position="left">活动奖励领取</van-divider>
    <div class="table_detail" style="margin-top:10px;">
      <table>
        <thead>
          <tr>
            <th>序号</th>
            <th>奖励明细</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ 1 }}</td>
            <td>品牌空气炸锅</td>
            <td>
              <van-button type="primary" size="small" disabled v-if="isreceive23==1">已领取</van-button>
              <van-button type="primary" size="small" disabled v-else-if="isreceive24==1">已领取其他奖励</van-button>
              <van-button type="primary" size="small" v-else-if="isreceive23==0&&isreceive24==0&&periodnum>=4" @click="receive(23,1)">立即领取</van-button>
              <van-button type="primary" size="small" disabled v-else>等待领取</van-button>
            </td>
          </tr>
          <tr>
            <td>{{ 2 }}</td>
            <td>品牌电压力锅</td>
            <td>
              <van-button type="primary" size="small" disabled v-if="isreceive24==1">已领取</van-button>
              <van-button type="primary" size="small" disabled v-else-if="isreceive23==1">已领取其他奖励</van-button>
              <van-button type="primary" size="small" v-else-if="isreceive23==0&&isreceive24==0&&periodnum>=6" @click="receive(24,2)">立即领取</van-button>
              <van-button type="primary" size="small" disabled v-else>等待领取</van-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
  
</template>
<script>
import { Button, Cell, CellGroup, NavBar, Image, Divider, Dialog } from "vant";
export default {
  data() {
    return {
      halfnum:0,
      periodnum:0,
      signstatus:"",
      // isreceive21:0,
      // isreceive22:0
      isreceive23:0,
      isreceive24:0,
      isAddr:0,
    };
  },
  created() {
    console.log(this.$route)
    if(this.$route.params.fromWechat){
      this.$router.go(0);
    }
    this.GetData();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    GetData() {
      var that = this;
      this.$http.get("Activity2025/GetPeriodReward", {
        params: {
          period: 2,
        },
      }).then((res) => {
        // that.halfnum = res.data.Data.HalfNum;
        that.periodnum = res.data.Data.ProcessNum;
        // that.signstatus = res.data.Data.SignStatus;
        that.isreceive23 = res.data.Data.IsReceive23;
        that.isreceive24 = res.data.Data.IsReceive24;
        that.isAddr = res.data.Data.IsAddr;
      });
    },
    receive(id) {
      var that = this;
      if(that.isAddr == 0){
        return this.$toast.fail("您的地址未填写，请先前往【个人中心】-【收货地址】填写地址！");
      }
      Dialog.confirm({
        title: "领取奖励",
        message:
          "是否确认领取该奖品，领取成功后无法更换?",
      })
      .then(() => {
        that.$http.get("Activity2025/GetPeriodActivityReward", {
          params: {
            taskId:id
          },
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("领取成功！请耐心等待奖品配送");
            that.$router.push({
              name: "PrizeAddrs",
              params: {},
            });
            // that.GetData();        
          } else {
            that.$toast(res.data);
          }
        });
      });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Divider.name]: Divider,
    [Dialog.name]: Dialog,
  },
};
</script>
<style scoped>


.image
{
  width:177px;
  height:35px;
  position:relative; 
}

@keyframes flicker{
0%,100%{
transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
opacity:1
}
90%{
transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
opacity:1
}

}
@-webkit-keyframes flicker{
0%,100%{
-webkit-transform:scale(1);
-moz-transform:scale(1);
-o-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-webkit-transform:scale(0.9);
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-moz-keyframes flicker{
0%,100%{
-moz-transform:scale(1);
-o-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-moz-transform:scale(0.9);
-o-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
@-o-keyframes flicker{
0%,100%{
-o-transform:scale(1);
-moz-transform:scale(1);
-webkit-transform:scale(1);
-ms-transform:scale(1);
transform:scale(1);
opacity:1
}
90%{
-o-transform:scale(0.9);
-moz-transform:scale(0.9);
-webkit-transform:scale(0.9);
-ms-transform:scale(0.9);
transform:scale(0.9);
opacity:1
}

}
.image {
-webkit-animation:flicker 0.8s infinite ease-in-out;
-moz-animation:flicker 0.8s infinite ease-in-out;
-o-animation:flicker 0.8s infinite ease-in-out;
animation:flicker 0.8s infinite ease-in-out
}
.image {
animation-delay:-0.8s;
-webkit-animation-delay:-0.8s;
-moz-animation-delay:-0.8s;
-o-animation-delay:-0.8s
}


.table_detail{
    overflow:auto;
    width: 100%;
    /* 固定滚动高度 */
    max-height: calc(100vh - 220px);
    border-top: 1px solid #EBEBEB;
    border-bottom: 1px solid #EBEBEB;
    border-right: 0;
    
  }
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  td, th {
    border-right: 1px solid #EBEBEB;
    border-bottom :1px solid #EBEBEB;
    width:100px;
    height: 35px;
    color: #333;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 5px 5px 5px 0;
  }
  th {
    background: #FAFAFA;
    color: #999;
    font-weight: normal;
  }
  /* 固定首列*/
  td:first-child,
  th:first-child {
    width:100px;
    position:sticky;
    left:0;
    z-index:1;
    padding-left: 5px;
  }
  /* 固定表头*/
  thead tr th {
    position:sticky;
    top:0;
  }
  th:first-child{
    z-index:2;
  }
  /* 固定表头*/
  tfoot tr th {
    position:sticky;
    bottom:0;
    color: #333;
    font-weight: bold;
    border-bottom: 0;
  }
  th:first-child{
    z-index:2;
  }
</style>
